import react, { useState, createContext, useEffect } from 'react';
export const ContextSearch = createContext({ valueSearch: [], onSearch: () => { } });

export const SearchProvider = ({ children }) => {
    const [valueSearch, setValueSearch] = useState([]);
    
    const handleSearch = (newData)=>{
        setValueSearch(newData);
        localStorage.setItem("valueSearch", JSON.stringify(newData));
    }
    return <ContextSearch.Provider value={{ valueSearch: valueSearch, onSearch: handleSearch }}>{children}</ContextSearch.Provider>;
}